import React from "react";
import Graphs from "../organisms/Graphs";
import NewsFeed from "../organisms/NewsFeed";
import UseLandingLoader from "../../hooks/useLandingLoader";

import { useSelector } from "react-redux";
import ProjectUserListing from "../organisms/ProjectUserListing";

const HomePage = () => {
  const { userType } = useSelector((state) => state.authReducer);

  UseLandingLoader();
  return (
    <div className="bg-grey-100 w-full">
      <div className="flex flex-col">
        <Graphs />
      </div>
      <div className="flex gap-x-10">
        <ProjectUserListing />
        <NewsFeed  />
      </div>
    </div>
  );
};

export default HomePage;
